<article
  (click)="handleClick()"
  [ngClass]="{
    'no-padding-for-bookmarks': app.isBookmark,
    'big-container': displayType === DisplayType.BIG,
    'small-container': displayType === DisplayType.SMALL,
  }"
  class="app-icon-container"
>
  <a class="select-none">
    @defer (on viewport) {
      @if (app.isBookmark) {
        <bookmark-icon
          [ngClass]="{
            'big-image': displayType === DisplayType.BIG,
            'small-image': displayType === DisplayType.SMALL,
          }"
          [bookmark]="app"
        />
      } @else {
        <img
          [ngClass]="{
            'big-image': displayType === DisplayType.BIG,
            'small-image': displayType === DisplayType.SMALL,
          }"
          class="select-none m-auto"
          [src]="app.appIconURL"
          alt=""
          disableContextMenu
          withFallbackImage
        />
      }
    } @placeholder {
      <div
        [ngClass]="{
          'big-image': displayType === DisplayType.BIG,
          'small-image': displayType === DisplayType.SMALL,
        }"
      ></div>
    }
  </a>
</article>
